<script setup lang="ts">
/**
 * @name GitInfo.vue
 * @version 1.0.0
 * @description Componente para mostrar información de git en la interfaz
 * @author
 * @changelog
 * 1.0.0 - 2024/12/19 - @santiago - Componente inicial
 */

import { computed } from 'vue'
import { GitInfoService } from '@/services/GitInfoService'

// Obtener información formateada de git
const formattedInfo = computed(() => GitInfoService.getFormattedInfo())
</script>
<template>
	<div class="git-info">
		<div class="git-info__header">
			<span style="color: #adb5bd">Información de Versión</span>
		</div>
		<div class="git-info__content">
			<div class="git-info__item">
				<span class="git-info__label">Versión:</span>
				<span class="git-info__value">{{ formattedInfo.version }}</span>
			</div>
			<div class="git-info__item" v-if="!formattedInfo.commit.includes('HEAD')">
				<span class="git-info__label">Commit:</span>
				<span class="git-info__value">{{ formattedInfo.commit }}</span>
			</div>
			<div class="git-info__item">
				<span class="git-info__label">Último Commit:</span>
				<span class="git-info__value">{{ formattedInfo.lastCommit }}</span>
			</div>
			<div class="git-info__item">
				<span class="git-info__label">Último Deploy:</span>
				<span class="git-info__value">{{ formattedInfo.lastDeploy }}</span>
			</div>
			<div class="git-info__item" v-if="formattedInfo.hasChanges">
				<span class="git-info__label">Estado:</span>
				<span class="git-info__value git-info__value--warning" style="font-size: 12px"> ⚠️ Hay cambios pendientes </span>
			</div>
		</div>
	</div>
</template>

<style scoped>
.git-info {
	border-radius: 8px;
	padding: 1rem;
	margin: 1rem 0;
	font-family: 'Courier New', monospace;
	font-size: 0.875rem;
}
.git-info__header {
	margin-bottom: 0.75rem;
}

.git-info__content {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.git-info__item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.25rem 0;
}

.git-info__label {
	font-weight: 500;
	color: #adb5bd;
	min-width: 120px;
}

.git-info__value {
	color: #adb5bd;
	font-weight: 400;
}

.git-info__value--warning {
	color: #dc3545;
	font-weight: 500;
}

@media (max-width: 768px) {
	.git-info__item {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.25rem;
	}

	.git-info__label {
		min-width: auto;
	}
}
</style>
